import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationExtras } from '@angular/router';
import { DatePipe } from '@angular/common';

import { Alert } from '../../../common/util/Alert';
import { ShipmentVarietySizeASN } from "../../../common/model/ShipmentVarietySizeASN";
import { ShipmentVarietySizeASNService } from "../../../common/facade/ShipmentVarietySizeASN.service";
import { ExcelUtility } from '../../../common/util/ExcelUtility';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
import { TableMessages } from '../../../common/util/TableMessages';

@Component({
  selector: 'app-shipments-asn-variety-detail',
  templateUrl: './shipments-asn-variety-detail.component.html',
  styleUrls: ['./shipments-asn-variety-detail.component.css']
})
export class ShipmentsAsnVarietyDetailComponent implements OnInit {
    private readonly path = 'inventory/shipments-asn-detail';

    loading = false;
    messageLoader = '';
    isSpanish = true;
    ShipmentManifestAsnId = 0;
    manifest = '';
    extras: NavigationExtras = {};

    rows: ShipmentVarietySizeASN[] = [];
    alerts: Alert[] = [];

    // Strings
    lblTitle = res.StylesVarietyASN;
    lblDeliveryCode = res.Delivery;
    lblAsnCodes = res.ASNCode;
    lblManifest = res.Manifest;
    lblSizeGroupDetCode = res.sizeGroupDetCode;
    lblStyleVariety = res.StyleVariety;
    lblTotalQuantity = res.Quantity;
    lblReceivedQuantity = res.Received;
    lblSize = res.Size;
    lblDownload = res.Download;
    lblSearch = res.Search;

    messagesTable: TableMessages = {
        emptyMessage: '',
        totalMessage: ''
    };

    private _filteredData: ShipmentVarietySizeASN[] = [];
    private _storeId = -1;
    private _startDate: string;
    private _endDate: string;
    private _organizationId = null;
    deliveryCode = '';

    constructor(
        private _service: ShipmentVarietySizeASNService,
        private _activatedRoute: ActivatedRoute,
        private _excel: ExcelUtility,
        private _datePipe: DatePipe,
        public strings: Strings
    ) {}

    ngOnInit(): void {
        this.loading = true;
        this.isSpanish = this.strings.getLanguageIsSpanish();
        this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
        this.messagesTable.totalMessage = this.strings.GetText(res.Total);

        this.ShipmentManifestAsnId = Number(this._activatedRoute.snapshot.paramMap.get('id'));

        const queryParams = this._activatedRoute.snapshot.queryParams;
        this._storeId = Number(queryParams['storeid']);
        this._startDate = queryParams['startDate'];
        this._endDate = queryParams['endDate'];
        this._organizationId = queryParams['organizationid'];
        this.deliveryCode = queryParams['deliveryCode'];

        this.extras = {
            queryParams: {
                startDate: this._startDate,
                endDate: this._endDate,
                storeid: this._storeId,
                organizationid: this._organizationId,
            }
        };

        this.loadDataFromService();
    }

    private loadDataFromService(): void {
        this._service.GetCollectionByManifestId(this.ShipmentManifestAsnId).subscribe(
            result => {
                if (result.completed && result.data) {
                    this.rows = result.data || [];
                    this._filteredData = result.data || [];
                    this.loading = false;
                } else {
                    this.addAlert('<strong>' + result.message + '</strong>', 'danger');
                    this.loading = false;
                }
            },
            error => {
                this.addAlert('<strong>Error: ' + error + '</strong>', 'danger');
                this.loading = false;
            }
        );
    }

    addAlert(message: string, type: string): void {
        this.alerts = [];
        this.alerts.push({ type, msg: message });
    }

    onClosed(dismissedAlert: Alert) {
        this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
    }

    updateFilter(event: KeyboardEvent): void {
        const val = (event.target as HTMLInputElement).value.toLowerCase();

        if (!val) {
            this.rows = [...this._filteredData];
            return;
        }

        if (this._filteredData.length === 0) {
            this.rows = [];
            return;
        }

        this.rows = this._filteredData.filter(item => {
            const keys = Object.keys(item);
            return keys.some(key => {
                const value = item[key];
                return value !== null &&
                       value !== undefined &&
                       value.toString().toLowerCase().includes(val);
            });
        });
    }

    downloadLayout(): void {
        if (this.rows.length > 0) {
            const data: any = [];
            this.rows.forEach(row => {
                const info = {
                    [this.strings.GetText(res.StyleVariety)]: row.styleVariety,                 
                    [this.strings.GetText(res.sizeGroupDetCode)]: row.sizeGroupDetCode,
                    [this.strings.GetText(res.Size)]: row.sizeName,
                    [this.strings.GetText(res.Quantity)]: row.totalQuantity,
                    [this.strings.GetText(res.Received)]: row.receivedQuantity,
                };
                data.push(info);
            });
            this._excel.exportAsExcelFile(data, this.strings.GetText(res.StylesVarietyASN));
        } else {
            this.addAlert(this.strings.GetText(res.AlertSelectActivityFirst), 'danger');
        }
    }
}
